// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const blue = "Insight__blue__skfOM";
export const body = "Insight__body__c-F4O";
export const bold = "700";
export const category = "Insight__category__bxJ8D";
export const content = "Insight__content__QfBHR";
export const footer = "Insight__footer__Wu7KF";
export const green = "Insight__green__zPziw";
export const hasNoTitle = "Insight__hasNoTitle__ef0lx";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const header = "Insight__header__-qRGi";
export const insight = "Insight__insight__DKQ08";
export const isHighlight = "Insight__isHighlight__6ATj3";
export const isModule = "Insight__isModule__3yQlM";
export const isPage = "Insight__isPage__BJSzg";
export const leftBadgeWrapper = "Insight__leftBadgeWrapper__oOK1S";
export const mediaImage = "Insight__mediaImage__VgLSe";
export const mediaPlaceholder = "Insight__mediaPlaceholder__+xDdA";
export const medium = "500";
export const noCard = "Insight__noCard__Ot5ie";
export const none = "Insight__none__Mmq8O";
export const notScrollable = "Insight__notScrollable__1r0p1";
export const notTouchable = "Insight__notTouchable__HPSJy";
export const orange = "Insight__orange__OHREP";
export const red = "Insight__red__RVAnK";
export const regular = "400";
export const rightBadgeWrapper = "Insight__rightBadgeWrapper__KRtlH";
export const sans = "'sans'";
export const scrollableWrapper = "Insight__scrollableWrapper__00ojQ";
export const semibold = "600";
export const serif = "'serif'";
export const sponsoredLabel = "Insight__sponsoredLabel__BsZ7U font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const text = "Insight__text__9EVry Text__bodyText__20Sxx font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const title = "Insight__title__StRiA font-faces__serifMedium__n-4rV font-faces__serif__XseuP";